import { render, staticRenderFns } from "./Others.vue?vue&type=template&id=0a2726c5&scoped=true"
import script from "./Others.vue?vue&type=script&lang=js"
export * from "./Others.vue?vue&type=script&lang=js"
import style0 from "./Others.vue?vue&type=style&index=0&id=0a2726c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2726c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
